export const USER_LOCALE_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";
